module.exports = __webpack_public_path__ + "static/media/icon-loading-tiffany.e5b12464.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-loading-tiffany.svg
// module id = 81
// module chunks = 0